import { useEffect, useRef } from "react";
import { CAMPAIGN_TYPES, INPUTS_PROPS } from "../../../../enums/Enums";
import Strings from "../../../../resources/Strings";
import classes from "./MessagingContentCard.module.css";
import { Divider } from "@mui/material";
import ContentEditable from "react-contenteditable";
import { CAMPAIGN_TYPE_LIST } from "../../../../constants/Constants";

const CampaignInfoContentCard = (props) => {
  const campaignInfo = {...props?.campaignInfo};
  const campaignType = CAMPAIGN_TYPE_LIST.find(i => i.value === campaignInfo?.Type);
  const contentEditableRef = useRef(null);

  useEffect(() => {
    if (contentEditableRef !== null) {
      // remove editable attribute - for readonly
      contentEditableRef.current.el.current.attributes?.removeNamedItem('contenteditable');
    }

  }, [contentEditableRef]);

  return (
    <div className={classes.contentCardContainer}>
      <Divider />
      <div className={classes.messagingContainer}>
        <div className={classes.messagingItem}>
          <div className={classes.total}>{Strings.INPUT_LABELS.CAMPAIGN_TYPE}</div>
          <div className={classes.total}>{campaignType?.label}</div>
        </div>
      </div>
      <Divider /> 
      {campaignInfo?.Type === CAMPAIGN_TYPES.MAIL && 
        <div className={classes.messagingContainer}>
          <div className={classes.messagingItem}>
            <div className={classes.total}>{Strings.INPUT_LABELS.EMAIL_SUBJECT}</div>
          </div>
          <div className={classes.messagingItem}>
            <div className={classes.total}>{campaignInfo?.Subject}</div>
          </div>
        </div>
      }
      <Divider />
      <div className={classes.messagingContainer}>
        {campaignType?.value === CAMPAIGN_TYPES.MAIL && 
          <div className={classes.messagingItem}>
            <div className={classes.total}>{Strings.INPUT_LABELS.EMAIL_BODY}</div>
          </div>
        }
        <div className={classes.messagingItem}>
          <div className={classes.total}>
            <ContentEditable 
              className={[classes.messageBody, classes.campaignInfo].join(' ')}
              id={INPUTS_PROPS.MESSAGE_BODY}
              html={campaignInfo?.Body}
              ref={contentEditableRef}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignInfoContentCard;